<form class="filters-form mb-4">
  <label class="form-control mb-0 flex-1">
    <div class="position-relative">
      <input
        type="search"
        name="main_pages_search"
        class="pr-5"
        [formControl]="searchControl"
        [placeholder]="'SEARCH' | translate"
        spellcheck="false"
      />

      <button
        type="button"
        class="postfix icon-button"
        attr.aria-label="{{ 'SEARCH' | translate }}"
      >
        <div [inlineSVG]="'assets/img/icons/search-icon-4.svg'"></div>
      </button>
    </div>
  </label>

  <div class="ml-auto">
    <button
      class="filter-button red"
      type="button"
      [disabled]="!selected?.length"
      [tooltip]="
        (!selected?.length
          ? 'BATCH_MAILING.RECEIPTS_TAB.ACTIONS.SELECT_TO_DELETE'
          : 'DELETE'
        ) | translate
      "
      triggers="pointerenter:pointerout"
      (click)="remove()"
    >
      <fa-icon class="filter-button-icon red" [icon]="faTrashAlt"></fa-icon>
      <span class="red">{{ 'DELETE' | translate }}</span>
    </button>
  </div>
</form>
